module.exports = __webpack_public_path__ + "img/incein-triangle.129e41cb.svg";